export const createMarkup = (data: string) => ({ __html: data })